import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';

import styles from '../styles.styl';

function VirtualAndOfficeVisitView({
  formatMessage,
  reasonType,
  providerView,
  personName,
  service,
  paymentDetails,
}) {
  return (
    <div styleName="row">
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({
              id: providerView
                ? 'appointment.list.card.patient'
                : 'appointment.list.card.provider',
            })}
          </div>
          <div className={styles.meta}>
            {formatMessage({ id: 'appointment.list.card.service' })}
          </div>
        </div>
        <div className={styles.column}>
          <span className={styles.provider}>{personName || '-'}</span>
          <div className={styles.provider}>{service}</div>
        </div>
      </div>
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({
              id: 'appointment.list.card.reasonForVisit',
            })}
          </div>
          <div className={styles.meta}>
            {formatMessage({
              id: providerView
                ? 'appointment.list.card.payment'
                : 'appointment.list.card.yourCost',
            })}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.provider}>{reasonType}</div>
          <div className={styles.provider}>{paymentDetails}</div>
        </div>
      </div>
    </div>
  );
}

VirtualAndOfficeVisitView.propTypes = {
  formatMessage: PropTypes.func,
  reasonType: PropTypes.string,
  providerView: PropTypes.bool,
  personName: PropTypes.string,
  service: PropTypes.string,
  paymentDetails: PropTypes.string,
};

export default CSSModules(VirtualAndOfficeVisitView, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/Views/VirtualAndOfficeVisitView.jsx